// material-ui
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';

// assets
import { IconThemeLight, IconThemeDark, IconThemeSystem } from 'utils/icons';

// ==============================|| THEME MODE SWITCH (LIGHT / DARK / SYSTEM) ||============================== //
// Manual override on top of the defaultMode="system" default set in themes/index.jsx.
// useColorScheme() reads/writes the same "theme-mode" localStorage key the
// ThemeProvider was given, so this stays in sync across the app.

export default function ThemeModeSwitch() {
  const { mode, setMode } = useColorScheme();

  const handleChange = (event, newMode) => {
    if (newMode !== null) setMode(newMode);
  };

  return (
    <Stack sx={{ alignItems: 'center' }}>
      <ToggleButtonGroup
        value={mode}
        exclusive
        size="small"
        onChange={handleChange}
        aria-label="barevné schéma"
        sx={{
          gap: 1,
          '& .MuiToggleButtonGroup-grouped': {
            margin: 0,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            color: 'text.secondary',
            '&.Mui-selected': { borderColor: 'primary.main', color: 'primary.main', bgcolor: 'transparent' },
            '&:hover': { borderColor: 'primary.light', bgcolor: 'transparent' }
          }
        }}
      >
        <ToggleButton value="light" aria-label="světlé">
          <IconThemeLight style={{ fontSize: '1.4rem' }} />
        </ToggleButton>
        <ToggleButton value="dark" aria-label="tmavé">
          <IconThemeDark style={{ fontSize: '1.4rem' }} />
        </ToggleButton>
        <ToggleButton value="system" aria-label="systém">
          <IconThemeSystem style={{ fontSize: '1.4rem' }} />
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
